import React from "react";

const CrudErrors = ({errors}) => {
    return (
        <div className="alert alert-danger" role="alert">
            Porfavor verificar los siguientes errores:
            <ul>{errors.map((e, i) => <li key={e.field + i}>{e.error}</li>)}</ul>
        </div>
    );
}
export default CrudErrors;
